import React, { useState } from "react";
import { Box, IconButton, Modal, Stack, TextField, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import { SAVE_PRODUCTS, SAVE_USER_SITES_PROJECTS } from "../../constant/Apipath";
import { English } from "../../constant/EnglishFallback";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";

const AddDescriptionModal = ({ open, onClose, from, data, onDataSave }) => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;

  const [description, setDescription] = useState("");

  const [submitLoading, setSubmitLoading] = useState(false);

  const {
    TEXT_DESCRIPTION = English?.Expenses?.TEXT_DESCRIPTION,
    TEXT_ADD_DESCRIPTION = English?.Expenses?.TEXT_ADD_DESCRIPTION
  } = multiLanguageData?.Expenses || {};

  const getSaveObj = () => {
    let saveObject = {
      userId: Number(currentUserId),
      ReturnRecordId: true,
      ReturnRecordError: true,
      SaveList: []
    };

    if (from === "product") {
      return {
        ...saveObject,
        SaveList: [
          {
            Id: data?.id,
            Name: data?.name,
            Info: description,
            webSite: data?.productWebSite,
            productType: data?.productType,
            ManufacturerId: data?.manufacturerId,
            ModifiedBy: Number(currentUserId),
            RecordStatusId: 1
          }
        ]
      };
    }

    if (from === "project") {
      return {
        ...saveObject,
        SaveList: [
          {
            Id: data?.id,
            UserId: Number(currentUserId),
            SiteId: data?.siteId,
            projectName: data.projectName,
            ProjectType: data?.projectType,
            ProjectWebsite: data?.projectWebsite,
            Description: description,
            IsActive: data?.isActive,
            ModifiedBy: Number(currentUserId),
            RecordStatusId: 1
          }
        ]
      };
    }
  };

  const getApiUrl = () => {
    let apiUrl = "";
    if (from === "product") {
      apiUrl = SAVE_PRODUCTS;
    }

    if (from === "project") {
      apiUrl = SAVE_USER_SITES_PROJECTS;
    }
    return apiUrl;
  };

  const onSubmit = async (e) => {
    try {
      e.preventDefault();
      setSubmitLoading(true);
      let obj = getSaveObj();
      await Postrequestcall(getApiUrl(), obj, loginData?.accessToken);
      onClose();
      onDataSave();
    } catch (error) {
      console.log("onSubmit-> Error When Saving Description Data: ", error);
      onClose();
    } finally {
      setSubmitLoading(false);
    }
  };

  return (
    <Modal open={open}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6" sx={{ ml: 1 }}>
            {TEXT_ADD_DESCRIPTION}
          </Typography>
          <Stack direction={"row"}>
            <IconButton onClick={() => onClose()}>
              <CloseIcon />
            </IconButton>
            <IconButton
              color="primary"
              loading={submitLoading}
              variant="contained"
              onClick={onSubmit}
              disabled={description?.trim() === "" || submitLoading}>
              <SaveIcon />
            </IconButton>
          </Stack>
        </Box>
        <TextField
          sx={{ p: 1 }}
          slotProps={{
            input: {
              rows: 5,
              multiline: true,
              inputComponent: "textarea"
            }
          }}
          minRows={4}
          autoFocus
          variant="outlined"
          label={TEXT_DESCRIPTION}
          fullWidth
          value={description}
          onChange={(e) => {
            let inputValue = e.target.value;
            inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
            setDescription(inputValue);
          }}
          onKeyPress={(event) => {
            if (event.key === "Enter" && description?.trim() !== "") onSubmit(event);
          }}
        />
      </Box>
    </Modal>
  );
};

export default AddDescriptionModal;
